import { render, staticRenderFns } from "./Movimientos.vue?vue&type=template&id=206ad370&scoped=true"
import script from "./Movimientos.vue?vue&type=script&lang=js"
export * from "./Movimientos.vue?vue&type=script&lang=js"
import style0 from "./Movimientos.vue?vue&type=style&index=0&id=206ad370&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206ad370",
  null
  
)

export default component.exports